module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[27]270.d13e10e.woff2";